import { SubscriptionPlanEnum } from "types/subscription/SubscriptionPlanEnum";

export enum PricingPlanPriceDisplayEnum {
  PRICE = "price",
  CONTACT_SALES = "contact_sales",
}

export enum PricingPlanCtaActionEnum {
  SIGNUP = "signup",
  EXTERNAL_LINK = "external_link",
  CONTACT_SALES = "contact_sales",
}

export interface PricingPlan {
  name: string;
  /** Shown in the price row when `priceDisplay` is `PRICE`. */
  price: string;
  period?: string;
  description: string;
  features: string[];
  cta: string;
  ctaAction: PricingPlanCtaActionEnum;
  ctaHref?: string;
  priceDisplay: PricingPlanPriceDisplayEnum;
  popular: boolean;
  /** Billing mechanics and limits context; shown in the card info tooltip. */
  detailsTooltip: string;
  /** Optional badge label rendered above the card (e.g. "Recommended"). Only shown when `popular` is also true. */
  badgeLabel?: string;
  /** Short reassurance line rendered below the CTA button (e.g. "No credit card required"). */
  trustLine?: string;
  /** Maps this landing-page plan to its backend subscription tier for checkout. Omitted for Enterprise (contact sales). */
  tierId?: SubscriptionPlanEnum;
}
